import React from 'react'
import {   Field} from 'redux-form'


const svinputRenderField = ({input, label, type, meta:{error, touched}})=>{
    return(

     
            <input {...input}  component="input" type="input"   className="form-control" />
           

    
       
    )

}

const normalizeNumber = value=>{

    let outValue = value
  
    if(!value){
        return outValue
    }

    const onlyNums = value.replace(/[^\d]/g, '')

    outValue = onlyNums
    console.log(onlyNums)
    return outValue
    //return outValue
}
export class SVCNumber extends React.Component{
    

    constructor(props){
        super(props)
        this.svchange   = this.svchange.bind(this)


    }
    componentWillReceiveProps(next){
        console.log('sv number')
        console.log(next)

    }

    

    render(){
        console.log('render SVNumber')
        console.log(this.props)

        let me = this

        let {name, placeholder ='Port Z'} = this.props
       
/*
        const {label,label_forName, input, type,
            meta:{
              touched, error, warning
            }
           } = this.props*/
          return (
           <Field className="form-control" 
           normalize={normalizeNumber} 
            type="text" 
             component={svinputRenderField}
             name={name}
            
              placeholder={placeholder} >
        
          </Field> )
           {/*  return (<div className="form-group">
                <label  forName={label_forName}>{label}
                </label>
                <input   onBlur={() => console.log('sv') }  {...input} type={type} id={portEntryId} className="form-control" placeholder="SVparalleltask"  />
                { touched && ((error && <span>{error}</span> )) || (warning && <span>{warning}</span>) }
            
            </div>
      
             )  
 */}
       

    }
}